/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { compose } from 'recompose';
import {
    bool, func, number, string,
} from 'prop-types';
import { trackEvent } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const Track = ({
    trackData, category = '', label = '', action = '', queued, nonInteraction,
}) => {
    trackData({
        eventCategory: category,
        eventAction: action,
        eventLabel: label || '<<pageType>>',
        queued,
        nonInteraction,
    });

    return null;
};

Track.defaultProps = {
    trackData: () => {},
    queued: true,
    action: '',
    label: null,
    category: '',
    nonInteraction: 1,
};

Track.propTypes = {
    trackData: func,
    category: string,
    label: string,
    action: string,
    queued: bool,
    nonInteraction: number,
};

const mapDispatchToProps = (dispatch) => ({
    trackData: bindActionCreators(trackEvent, dispatch),
});

const enhance = compose(
    connect(null, mapDispatchToProps),
);

export default enhance(Track);
